export default {
  title: 'Resumo de Vendas',
  description: 'Vendas do período selecionado — utilize para reconciliação de faturação com este restaurante.',
  filters: {
    period: 'Período',
  },
  presets: {
    this_month: 'Este mês',
    last_month: 'Mês passado',
    last_30_days: 'Últimos 30 dias',
    this_year: 'Este ano',
  },
  fields: {
    orders_count: 'Encomendas',
    net_sales: 'Vendas Líquidas',
    sales_tax: 'IVA',
    gross_sales: 'Vendas Brutas',
    delivery_fee_tax: 'Taxa de entrega (imposto)',
    delivery_fee_gross: 'Taxa de entrega (bruto)',
    tips_gross: 'Gorjetas (bruto)',
    total: 'Total',
  },
  kpi: {
    before_tax: 'antes de imposto',
    tips: 'cobrado para o restaurante',
    owed_to_restaurant: 'devido ao restaurante',
  },
  table: {
    title: 'Detalhes',
    subtitle: '{{range}} · Todos os valores em {{currency}}',
    field: 'Campo',
    amount: 'Valor',
    empty: 'Sem encomendas no período selecionado',
    footnote:
      'Vendas Líquidas excluem imposto; Vendas Brutas incluem-no · Total líquido de comissões da plataforma, não corresponde ao valor pago pelo cliente · Reembolsos e estornos são deduzidos · Valores em {{currency}}',
  },
  buttons: {
    export_csv: 'Exportar CSV',
    refresh: 'Atualizar',
    retry: 'Tentar novamente',
  },
  errors: {
    failed_to_load: {
      title: 'Não foi possível carregar o resumo de vendas',
      description: 'Ocorreu um erro ao carregar o relatório. Por favor, tente novamente.',
    },
  },
};
